import { Box, VStack, useColorModeValue } from '@chakra-ui/react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ServicesSection from './sections/ServicesSection';
import ProjectsSection from './sections/ProjectsSection';
import ProcessSection from './sections/ProcessSection';
import AlliesSection from './sections/AlliesSection';
import ContactSection from './sections/ContactSection';

function App() {
  const bgGradient = useColorModeValue(
    'radial-gradient(circle at top, #f8fafc, #e2e8f0 55%)',
    'radial-gradient(circle at top, #1c2a39, #0d1117 55%)'
  );

  return (
    <Box minH="100vh" bg={bgGradient}>
      <Header />
      <VStack as="main" spacing={{ base: 16, md: 24 }} pb={{ base: 16, md: 20 }}>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProjectsSection />
        <ProcessSection />
        <AlliesSection />
        <ContactSection />
      </VStack>
      <Footer />
    </Box>
  );
}

export default App;
